import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d9bb53a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-organization-card__header" }
const _hoisted_2 = { class: "user-organization-card__info" }

import { PropType, computed } from 'vue'
import { OrganizationType } from '@/shared/types'
import { getDateDistance } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  organization: Object as PropType<OrganizationType>,
  active: Boolean as PropType<boolean>,
  blocked: Boolean as PropType<boolean>,
},
  setup(__props) {

const props = __props



const dateDistance = computed(() => {
  return getDateDistance(props.organization.block_at)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user-organization-card", {
      'user-organization-card--active': __props.active,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", {
        class: _normalizeClass(["user-organization-card__name", {
          'user-organization-card__name--blocked': __props.blocked,
        }])
      }, _toDisplayString(__props.organization.name), 3)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, "Врачей: " + _toDisplayString(__props.organization.users_count), 1),
      (!__props.organization.is_blocked)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("p", null, " Дней: " + _toDisplayString(_unref(dateDistance)), 1),
            _createElementVNode("p", null, "Отчетов: " + _toDisplayString(__props.organization.package_count), 1)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})